'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  HeadFootPanel: {
    displayName: 'HeadFootPanel'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/HeadFootPanel/HeadFootPanel.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var HeadFootPanel = _wrapComponent('HeadFootPanel')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(HeadFootPanel, _Component);

  function HeadFootPanel() {
    (0, _classCallCheck3.default)(this, HeadFootPanel);
    return (0, _possibleConstructorReturn3.default)(this, (HeadFootPanel.__proto__ || (0, _getPrototypeOf2.default)(HeadFootPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(HeadFootPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var self = this;
      var oldSize = -1;
      // let velikostUstanovena = false;
      var _self$refs = self.refs,
          box = _self$refs.box,
          body = _self$refs.body;


      var counter = 1;

      var checkFunc = function checkFunc(mycounter) {
        if (mycounter && mycounter !== counter) return; // další volání funkce bude následovat.
        var newSize = box.offsetHeight;
        // window.__box = box;

        // console.log(oldSize);
        if (newSize === oldSize) return;
        oldSize = newSize;
        // console.log('redrawing HeadFootPanel   ');
        body.style.height = newSize + 'px';
      };
      self.__interval = setInterval(checkFunc, 500);

      self.__resizeGuard = function () {
        var counterNow = ++counter;
        setTimeout(function () {
          return checkFunc(counterNow);
        }, 100);
      };
      addEventListener('resize', self.__resizeGuard);
      body.style.position = 'absolute';
      // body.style.overflow = 'auto';
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      removeEventListener('resize', this.__resizeGuard);
      clearInterval(this.__interval);
      console.log('Unmounted HeadFootPanel');
    }

    // https://css-tricks.com/snippets/css/a-guide-to-flexbox/

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          header = _props.header,
          children = _props.children,
          footer = _props.footer,
          className = _props.className; // eslint-disable-line no-shadow

      var styles = require('./HeadFootPanel.scss');

      return _react3.default.createElement(
        'div',
        { className: styles.headFootPanel + (className ? ' ' + className : '') },
        _react3.default.createElement(
          'table',
          { ref: 'table' },
          _react3.default.createElement(
            'tbody',
            null,
            _react3.default.createElement(
              'tr',
              null,
              _react3.default.createElement(
                'td',
                { ref: 'header' },
                header
              )
            ),
            _react3.default.createElement(
              'tr',
              null,
              _react3.default.createElement(
                'td',
                { ref: 'box' },
                _react3.default.createElement(
                  'div',
                  { ref: 'body', className: 'scrollable', style: { width: '99%' } },
                  children
                )
              )
            ),
            _react3.default.createElement(
              'tr',
              null,
              _react3.default.createElement(
                'td',
                { ref: 'footer' },
                footer
              )
            )
          )
        )
      );
    }
  }]);
  return HeadFootPanel;
}(_react2.Component), _class.propTypes = {
  className: _react2.PropTypes.string,
  children: _react2.PropTypes.oneOfType([_react2.PropTypes.arrayOf(_react3.default.PropTypes.node), _react2.PropTypes.node]),
  header: _react2.PropTypes.oneOfType([_react2.PropTypes.arrayOf(_react3.default.PropTypes.node), _react2.PropTypes.node]),
  footer: _react2.PropTypes.oneOfType([_react2.PropTypes.arrayOf(_react3.default.PropTypes.node), _react2.PropTypes.node])
}, _temp));

exports.default = HeadFootPanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HeadFootPanel/HeadFootPanel.js
// module id = 1178
// module chunks = 0